/** ChatItem → Riley card/citation mappers. No component imports: test fixtures load this module on its own. */
import type { ChatItem } from '../lib/types'
import type { RileyCard, RileyCitation } from './riley/contracts'

const CITATION_TYPE: Record<string, RileyCitation['type']> = {
  desk: 'desk_thread',
  conduit: 'conduit_record',
  kb: 'kb',
  pbx: 'pbx',
  unifi: 'unifi',
  ninja: 'ninja',
  cambium: 'cambium',
  zabbix: 'zabbix',
  books: 'books_invoice',
  other: 'triage_log',
}

export function citationsOf(item: ChatItem): RileyCitation[] {
  return (item.citations ?? []).map((citation) => ({
    type: citation.selfWrite ? 'riley_writeback' : (CITATION_TYPE[citation.kind ?? 'other'] ?? 'triage_log'),
    id: citation.label,
    label: citation.label,
    internal_only: Boolean(citation.internalOnly),
  }))
}

function scrubReportOf(value?: string): Record<string, number> | null {
  if (!value) return null
  const report: Record<string, number> = {}
  for (const match of value.matchAll(/(\d+)\s+([a-z ]+?)(?:,|$)/gi)) {
    const label = match[2]
    if (label) report[label.trim().replaceAll(' ', '_')] = Number(match[1])
  }
  return Object.keys(report).length ? report : null
}

/** A card for display from a ChatItem's summary (when no real card rides along it cannot be confirmed). */
export function chatItemCard(item: ChatItem & { card: NonNullable<ChatItem['card']> }): RileyCard {
  const { card } = item
  return {
    id: item.id,
    kind: card.kind,
    title: card.title,
    audience: card.impact.audience === 'nobody' ? 'internal' : card.impact.audience,
    executor: card.executor,
    impact_text: card.impact.text,
    preview: card.detail ? { note: card.detail } : {},
    payload: {},
    scrub_report: scrubReportOf(card.scrubReport),
    state: 'proposed',
    can_confirm: false,
  }
}
